import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    logoutUrl: PropTypes.string.isRequired,
    remainingSessionTimeInMs: PropTypes.string.isRequired
};

class SessionTimerContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            remainingSessionTimeInMs: props.remainingSessionTimeInMs,
            logoutUrl: props.logoutUrl
        };

        this.setupSessionTimeout = this.setupSessionTimeout.bind(this);
        this._whenSessionTimerEnds = this._whenSessionTimerEnds.bind(this);
        this.setupSessionTimeout();
    }

    setupSessionTimeout() {
        if (typeof this.time !== 'undefined') {
            this.timer = clearTimeout(this.timer);
        }

        this.timer = setTimeout(this._whenSessionTimerEnds, this.state.remainingSessionTimeInMs);
    }

    _whenSessionTimerEnds() {
        window.onbeforeunload = null;
        document.location.href = this.state.logoutUrl + '?session=expired';
    }

    render() {
        return <div />;
    }
}

SessionTimerContainer.propTypes = propTypes;

export default SessionTimerContainer;
